import actions from './Actions';
import getters from './Getters';
import mutations from './Mutations';
import persist from './Persist';
import state from './State';

/**
 * @examples
 *
 * 	// Initialize on app start
 * 	Service.VersionHistory.initialize();
 *
 * 	// Show "what's new" on upgrade
 * 	if (Service.VersionHistory.didJustUpgrade()) {
 * 	    this.showWhatsNewModal();
 * 	}
 *
 * 	// Re-prompt for push notifications (version-based, not date-based)
 * 	if (!Service.VersionHistory.hasSeenSince('3.27.0')) {
 * 	    this.promptForPushNotifications();
 * 	}
 *
 * 	// Highlight a new feature
 * 	if (Service.VersionHistory.isFirstTimeInVersion()) {
 * 	    this.highlightNewFeature();
 * 	}
 *
 * 	// Check specific version
 * 	if (!Service.VersionHistory.hasSeenVersion('3.25.0')) {
 * 	    // User has never seen 3.25.0
 * 	}
 *
 *
 * ----------------------------------------------------------------------------
 *
 * Separate from global namespace. If we namespace it, you can access like:
 *
 * Getters:
 * 		store.getters['versionHistory/getterName'];
 *
 * State:
 * 		store.state.versionHistory.stateName;
 *
 * Actions:
 * 		store.dispatch('versionHistory/actionName');
 *
 */
const namespaced = true;

/**
 * Configure plugins
 */
const plugins = [persist];

// Setup Store
// -----------------------------------------------------------------------------

export default {
	/**
	 * Triggerable actions
	 * e.g. store.dispatch('versionHistory/initialize');
	 */
	actions,

	/**
	 * Calculated values based off state
	 * e.g. store.getters['versionHistory/seenVersions'];
	 */
	getters,

	/**
	 * Mutations are a way of modifying state indirectly
	 * e.g. store.commit('versionHistory/addSeenVersion', '3.27.0');
	 */
	mutations,

	/**
	 * Separate getters and actions from global namespace
	 */
	namespaced,

	/**
	 * Vuex Plugin for persisting data across sessions
	 */
	plugins,

	/**
	 * Raw object of our current state
	 */
	state,
};
